import { BannerContent2 } from '../../homeStyles';
import {
  ButtonBack,
  Divider,
  PlanListContent,
  SignPlanContainer,
  SignPlanHeader,
} from './styles';
import BFBanner from '../../../../../assets/Web.png';
import { CardPlanFree } from './components/CardPlanFree';
import { CardPlanPromo } from './components/CardPlanPromo';
import { CardPlanPremium } from './components/CardPlanPremium';

export function Pagamentos() {
  return (
    <SignPlanContainer>
      <ButtonBack onClick={() => {}}>Planos</ButtonBack>
      <div
        style={{
          width: '100%',
          height: '100%',
          overflow: 'auto',
          paddingTop: 50,
        }}
        >
        <SignPlanHeader>
          {/* <BannerContent2 src={BFBanner} /> */}
          <Divider />
        </SignPlanHeader>
        <PlanListContent>
          {/* Lista de planos */}
          <CardPlanFree />
          <CardPlanPromo />
          <CardPlanPremium />
        </PlanListContent>
      </div>
    </SignPlanContainer>
  );
}
